"use client";
import Script from "next/script";
import { useMatchMedia } from "@jetblue/kit/hooks/use-match-media";
import React from "react";
import config from "@jetblue/kit-tailwind-config";

type QualtricsInjectorProperties = {
  readonly interceptId: string;
  readonly src: string;
};

export function QualtricsInjector({
  interceptId,
  src,
}: QualtricsInjectorProperties) {
  const [isClient, setIsClient] = React.useState(false);
  const isMobile = useMatchMedia(`(max-width: ${config.theme.screens.md})`);

  React.useEffect(() => {
    setIsClient(true);
  }, []);

  if (!isClient || isMobile || !src || !interceptId) {
    return null;
  }

  return (
    <>
      <Script src={src} />
      <aside aria-label="Survey" id={interceptId}></aside>
    </>
  );
}
